import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './styles.module.css';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FC, useState } from 'react';
import Button from '../../Button';
import Modal from '../../Modal';

export type InCalculationProps = {
  onCancel: () => void;
};
const InCalculation: FC<InCalculationProps> = ({ onCancel }) => {
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const openModal = () => setIsCancelModalOpen(true);
  const onModalClose = () => {
    setIsCancelModalOpen(false);
  };
  const cancelModal = () => {
    return (
      <Modal onRequestClose={onModalClose}>
        <div className={styles.modalHead}>計算をやめますか？</div>
        <div className={styles.modalContent}>
          <div className={styles.modalText}>
            計算をやめると、計算前の状態に戻ります。
            <br />
            計算をやめてもよろしいですか？
          </div>
          <div className={styles.modalButtons}>
            <div className={styles.modalButton}>
              <Button
                type="button"
                onClick={onModalClose}
                variants={['fit', 'cancel']}
              >
                計算を続ける
              </Button>
            </div>
            <div className={styles.modalButton}>
              <Button
                type="button"
                onClick={() => {
                  onCancel();
                  onModalClose();
                }}
                variants={['fit']}
              >
                計算をやめる
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  };
  return (
    <>
      <div className={styles.container}>
        <div className={styles.controls}>
          <div className={styles.textContainer}>
            <FontAwesomeIcon icon={faSpinner} className={styles.icSpinner} />
            <span className={styles.controlText}>計算を実行中です...</span>
          </div>
          <Button onClick={openModal} variants={['cancel', 'contain']}>
            キャンセル
          </Button>
        </div>
        <div className={styles.loadbarContainer}>
          <div className={styles.loadbar}></div>
        </div>
      </div>
      {isCancelModalOpen && cancelModal()}
    </>
  );
};
export default InCalculation;
